// assets/cicatribem-cart.js
// Controlador final para o minicart, usando a estratégia de refresh para garantir 100% de consistência.

class CicatribemMinicartController {
   constructor() {
    // Aguarda o carregamento completo da página para evitar conflitos
    window.addEventListener('load', () => {
        this.cartDrawer = document.getElementById('minicart_wrapper');
        if (!this.cartDrawer) return;

        this.isUpdating = false;

        this.reopenCartOnLoad();
        this.initListeners();
        this.initOutsideClickClose();
    });
  }

  // Fecha o drawer ao clicar em qualquer lugar fora dele
  initOutsideClickClose() {
    document.addEventListener('click', (event) => {
      if (!document.documentElement.classList.contains('open-minicart')) return;
      if (event.target.closest('#minicart_wrapper')) return;
      if (event.target.closest('a#cart-icon-bubble, .minicart__action, [href$="/cart"]')) return;

      const cartNotif = document.querySelector('cart-notification#minicart_wrapper');
      if (cartNotif && typeof cartNotif.close === 'function') {
        cartNotif.close();
        return;
      }
      const inner = document.querySelector('#minicart_wrapper .minicart__wrapper');
      if (inner) inner.classList.remove('open');
      const wrap = document.getElementById('minicart_wrapper');
      if (wrap) wrap.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-minicart');
    });
  }

  setLoading(btn) {
      if(this.isUpdating) return false; // Previne cliques duplos
      this.isUpdating = true;
      if (btn) {
          btn.disabled = true;
          // Adiciona um feedback visual de carregamento
          btn.style.opacity = '0.7';
      }
      // Adiciona uma classe ao carrinho para mostrar um overlay de carregamento, se desejado
      this.cartDrawer.classList.add('is-updating');
      return true;
  }

  // Parte 1: Lógica para reabrir o carrinho ao carregar a página
  reopenCartOnLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open_cart')) {
      const cartIcon = document.querySelector('.header__icon--cart, a[href="/cart"], .site-header__cart, .js-open-cart');
      if (cartIcon) {
        // Atraso para garantir que todos os outros scripts do tema já foram carregados
        setTimeout(() => cartIcon.click(), 200);
      }
      // Limpa a URL para que o carrinho não abra em futuros refreshes
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  // Parte 2: Adiciona os listeners para as ações do usuário
  initListeners() {
    // Usar delegação de eventos para capturar cliques mesmo em conteúdo que muda
    this.cartDrawer.addEventListener('click', (event) => {
        // Override nos botões de quantidade para forçar o refresh
        const quantityButton = event.target.closest('.quantity__button');
        if (quantityButton) {
            event.preventDefault();
            const input = quantityButton.parentElement.querySelector('.quantity-input');
            const __it = quantityButton.closest('.cart-item');
            const __all = __it ? __it.parentElement.querySelectorAll('.cart-item') : [];
            const lineKey = __it ? Array.from(__all).indexOf(__it) + 1 : null;
            if (!lineKey) return;
            const currentQuantity = parseInt(input.value, 10);
            const newQuantity = quantityButton.name === 'plus' ? currentQuantity + 1 : currentQuantity - 1;

            if (newQuantity >= 0 && this.setLoading(quantityButton)) {
                this.updateItemQuantity(lineKey, newQuantity);
            }
        }

        // Override no botão de remover
        const removeButton = event.target.closest('cart-remove-button');
        if(removeButton) {
            event.preventDefault();
            const __it = removeButton.closest('.cart-item');
            const __all = __it ? __it.parentElement.querySelectorAll('.cart-item') : [];
            const lineKey = __it ? Array.from(__all).indexOf(__it) + 1 : null;
            if (!lineKey) return;
            if(this.setLoading(removeButton)) {
                this.updateItemQuantity(lineKey, 0);
            }
        }
    });

    this.cartDrawer.addEventListener('submit', (event) => {
      // Formulário de cupom
      const couponForm = event.target.closest('.coupon-form');
      if (couponForm) this.handleCouponSubmit(event, couponForm);
    });
  }

  handleCouponSubmit(event, form) {
    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const btn = form.querySelector('button');
    const code = input.value.trim();

    if (!code || !this.setLoading(btn)) return;

    btn.textContent = 'Aplicando...';

    // Redireciona para aplicar o cupom e então recarrega a página com o parâmetro de reabertura
    const redirectUrl = encodeURIComponent(window.location.pathname + '?open_cart=true');
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirectUrl}`;
  }

  updateItemQuantity(lineKey, quantity) {
      fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: lineKey, quantity: quantity, sections: ['minicart'], sections_url: window.location.pathname })
      })
      .then(r => r.json())
      .then(data => {
          if (data && data.sections && data.sections.minicart) {
              const parsed = new DOMParser().parseFromString(data.sections.minicart, 'text/html');
              const newForm = parsed.getElementById('minicart-form');
              const cur = document.getElementById('minicart-form');
              if (newForm && cur) cur.innerHTML = newForm.innerHTML;

              // 🔧 Atualiza a barra de frete grátis com o novo subtotal
              const newBar = parsed.querySelector('free-ship-progress-bar');
              const curBar = document.querySelector('free-ship-progress-bar');
              if (newBar && curBar) curBar.outerHTML = newBar.outerHTML;

              document.querySelectorAll('.cart-count').forEach(el => {
                  el.textContent = el.classList.contains('cart-count-drawer') ? `(${data.item_count})` : (data.item_count > 100 ? '~' : data.item_count);
              });
              const fs = document.querySelector('free-ship-progress-bar');
              if (fs && fs.init) fs.init(data.items_subtotal_price);
              this.isUpdating = false;
              this.cartDrawer.classList.remove('is-updating');
          } else {
              window.location.reload();
          }
      }).catch(() => {
          window.location.reload();
      });
  }
}

new CicatribemMinicartController();
